import { createContext } from 'react';
import { FilterContextType } from '#advertList/components/filter/contexts/FilterContextType';

const FilterContext = createContext<FilterContextType>(null);

export { FilterContext };
